import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const InfoBanner = ({ children, cta = "En savoir plus", to = "/", color = "bg-sky-soft" }) => (
  <div className={`${color} rounded-3xl py-5 px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-4 max-w-4xl mx-auto`}>
    <p className="font-serif-display text-stone-700 text-lg text-center md:text-left">{children}</p>
    <Link
      to={to}
      className="shrink-0 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-deep-rose font-serif-display tracking-wide hover:bg-blush-light transition-colors"
    >
      {cta} <ArrowRight size={16} />
    </Link>
  </div>
);

export default InfoBanner;
